"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./crud.abstract.service"));
__export(require("./http.abstract.service"));
//# sourceMappingURL=index.js.map